














import { defineComponent, reactive } from '@vue/composition-api'

import { UserState } from '@/types/store'
import { UserRole } from '@/types/user'
import useVuex from '@/utils/useVuex'

import Layout from '@/components/organisms/common/Layout.vue'
import { UserDetail } from '@/components/organisms/user-edit'

export default defineComponent({
  name: 'UserEdit',
  components: { Layout, UserDetail },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
    })

    return { state, UserRole }
  },
})
